import { useAnalyticsChoice } from "@/components/consent/analyticsChoice";
import { actionProps } from "@/lib/controlAnalytics";
import { ROUTES } from "@/lib/routes";
import PlaceLink from "./PlaceLink";

const LINKS: readonly { label: string; to: string; plain?: true }[] = [
    { label: "Pricing", to: ROUTES.PRICING },
    // Plain: a link that loads a new page, because an ad tag that has
    // started keeps running after a move inside the app, and no ad tag may
    // run on a page that holds a resume (lib/ads).
    { label: "Free tools", to: ROUTES.TOOLS, plain: true },
    { label: "Privacy", to: ROUTES.PRIVACY },
    { label: "Terms", to: ROUTES.TERMS },
    { label: "Support", to: ROUTES.SUPPORT },
];

/**
 * The foot of every page: the name, and Pricing, Free tools, Privacy,
 * Terms and Support, and Analytics, which asks the analytics question
 * again. What signing in with Google shares is the privacy policy's to say.
 */
export default function SiteFooter() {
    const analytics = useAnalyticsChoice();
    return (
        <footer className="mx-auto mt-12 w-full max-w-[1240px] px-8 pb-10 text-[13px] text-fg-muted max-[760px]:px-4 max-[760px]:pb-28">
            <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line pt-5">
                <span>Job Envoy</span>
                <nav aria-label="Footer" className="flex flex-wrap gap-x-[18px] gap-y-1">
                    {LINKS.map((link) =>
                        link.plain ? (
                            <a
                                {...actionProps("navigation_clicked", {
                                    source: "SiteFooter",
                                    target: link.to,
                                })}
                                key={link.to}
                                href={link.to}
                                className="hover:text-fg"
                            >
                                {link.label}
                            </a>
                        ) : (
                            <PlaceLink
                                {...actionProps("navigation_clicked", {
                                    source: "SiteFooter",
                                    target: link.to,
                                })}
                                key={link.to}
                                to={link.to}
                                className="hover:text-fg"
                            >
                                {link.label}
                            </PlaceLink>
                        ),
                    )}
                    {analytics && (
                        <button
                            {...actionProps("analytics_choice_opened", { source: "SiteFooter" })}
                            type="button"
                            onClick={analytics.open}
                            className="border-0 bg-transparent p-0 text-[13px] text-fg-muted hover:text-fg"
                        >
                            Analytics
                        </button>
                    )}
                </nav>
            </div>
        </footer>
    );
}
